var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'hab-left-filter-time-of-day',
    {
      active: _vm.active,
    },
  ],on:{"click":_vm.onClick}},[_c('p',{staticClass:"text-13-500 mb-4"},[_vm._v(_vm._s(_vm.dataSource.name))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.dataSource.time[0])+" - "+_vm._s(_vm.dataSource.time[1]))])])
}
var staticRenderFns = []

export { render, staticRenderFns }